import React from 'react';
import { Path, useFormContext, useWatch } from 'react-hook-form';
import { FinanceDetails } from './FinanceDetails';
import { InitializeWorkflow } from './InitializeWorkflow';
import { FinanceProgramFormValues } from '../../../../../../types';

interface Props {
  configuration?: Partial<Record<Path<FinanceProgramFormValues>, boolean>>;
}

export const Finance = ({ configuration }: Props) => {
  const { control } = useFormContext<FinanceProgramFormValues>();
  const createProposalWithExistingProgram = useWatch({
    control,
    name: 'financeQuote.createProposalWithExistingProgram',
  });

  const isShowDetailsFields = createProposalWithExistingProgram !== null;

  return (
    <>
      <InitializeWorkflow configuration={configuration} />
      {isShowDetailsFields && <FinanceDetails />}
    </>
  );
};
